import React from "react";
import "./HeaderPrintForm.scss";
import {logoFullWhite, logoIconWhite} from "assets/images/logo/";
import {logoBill} from "assets/images/logo/";
import {Col, Divider, Row, Typography, Watermark} from "antd";
import {CallSVG, CaptivePortalSVG, MailWhiteSVG} from "assets";
import {ReactComponent as PhoneSVG} from "assets/icons/phone-svg.svg";
import {ReactComponent as MailSVG} from "assets/icons/mail-svg.svg";
import {ReactComponent as InternetSVG} from "assets/icons/internet-svg.svg";
import {ReactComponent as LocationSVG} from "assets/icons/location-svg.svg";
const HeaderPrintForm = props => {
  const {type = 1} = props;
  return (
    <div className="header-print-form">
      <Row
        align={"middle"}
        justify={"space-between"}
        style={{padding: "0 10px 0 8px"}}
      >
        <Col span={22}>
          {type == 1 && (
            <>
              <Row>
                <Typography.Text strong style={{fontSize: "16px"}}>
                  Bệnh viện chuyên khoa mắt Alina
                </Typography.Text>
              </Row>
              <Row gutter={8} justify={"space-between"}>
                <Col span={9}>
                  <Row style={{alignItems: "flex-start"}} align={"middle"}>
                    <Col flex={"auto"}>
                      <LocationSVG />
                    </Col>
                    <Col span={22}>
                      <Typography.Text style={{fontSize: "14px"}}>
                        Địa chỉ: Biệt thự Mimosa 10-11-12, KĐT Ecopark, Văn
                        Giang, Hưng Yên
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={4}>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <Col>
                      <PhoneSVG />
                    </Col>
                    <Col>
                      <Typography.Text style={{fontSize: "14px"}}>
                        0866.224.883
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <Col>
                      <MailSVG />
                    </Col>
                    <Col>
                      <Typography.Text style={{fontSize: "14px"}}>
                        cskh@alinavision.com
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={5}>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <Col>
                      <InternetSVG />
                    </Col>
                    <Col>
                      <Typography.Text style={{fontSize: "14px"}}>
                        http://alinavn.com
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
          {type == 2 && (
            <>
              <Row>
                <Typography.Text strong style={{fontSize: "16px"}}>
                  TRUNG TÂM KÍNH MẮT VINMEC-ALINA
                </Typography.Text>
              </Row>
              <Row gutter={8} justify={"space-between"}>
                <Col span={4}>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <Col>
                      <PhoneSVG />
                    </Col>
                    <Col>
                      <Typography.Text style={{fontSize: "14px"}}>
                        Hotline: 0912953954
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <Col>
                      <MailSVG />
                    </Col>
                    <Col>
                      <Typography.Text style={{fontSize: "14px"}}>
                        cskh@alinavision.com
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={5}>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <Col>
                      <InternetSVG />
                    </Col>
                    <Col>
                      <Typography.Text style={{fontSize: "14px"}}>
                        http://alinavn.com
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </Col>
        <Col flex={"auto"}>
          <Row justify={"end"}>
            <img
              src={logoBill}
              style={{
                height: "32px",
              }}
            />
          </Row>
        </Col>
      </Row>
      <div style={{border: "1px solid #d9d9d9"}}></div>
    </div>
  );
};
export default HeaderPrintForm;
